
import { Card, CardActionArea, CardContent, Container, Typography } from "@mui/material";
import { Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Link } from 'react-router-dom';
import IniciaisLetras from '../../../utils/iniciaisLetras';
// import CardServices from '../../../utils/cardServices';

export default function CarousselDestaques({ definicoesSistema }) {

  function CardServices({ status, icone, nomeService, link }) {
    return (
      <Card>

        <CardActionArea
          disabled={!status}
          className="tw-text-center tw-mx-auto  tw-h-[180px]  md:tw-min-w-[220px] md:tw-h-[200px] tw-bg-white tw-border tw-border-[#85287e] tw-rounded-[10px] tw-transition tw-duration-500 tw-ease-in-out hover:tw-scale-110 hover:tw-border-black"
        >
          <Link className="tw-no-underline" to={link}>
            <CardContent>
              {icone ?
                <div className="tw-h-[50px] tw-flex tw-items-center">
                  <img src={icone} alt="" className="tw-h-[75px] tw-mx-auto" />
                </div>
                :
                <Typography align="center" color="textSecondary" variant="h3">
                  <IniciaisLetras frase={nomeService} />
                </Typography>
              }
            </CardContent>

            <CardContent>
              <Typography color="textPrimary" variant="body1" className="tw-text-[14px] tw-text-center">
                {nomeService}
              </Typography>
            </CardContent>
          </Link>
        </CardActionArea>
      </Card>
    )
  }


  const serviceStatus = (servico) => {
    if (definicoesSistema?.servicos.includes(servico)) return true;
  }

  return (
    // 
    <div
      style={{ backgroundImage: `url('/img/backGrounds/BgComprimido2.jpg')` }}
      className="tw-mt-[100px] tw-mb-[20px] tw-p-[20px] tw-flex tw-items-center tw-min-h-[40vh] tw-bg-cover tw-bg-center tw-bg-fixed tw-shadow-[1rem_1rem_1rem_#e7f0ed]">

      <Container>
        <Typography align="center" variant="h1" className="tw-m-4 tw-text-[25px] tw-font-bold tw-text-white">
          DESTAQUES
        </Typography>

        <Swiper
          breakpoints={{
            // Configurações quando a largura da tela for >= 320px
            320: {
              slidesPerView: 1,
              spaceBetween: 10
            },
            // Configurações quando a largura da tela for >= 480px
            480: {
              slidesPerView: 2,
              spaceBetween: 20
            },
            // Configurações quando a largura da tela for >= 768px
            768: {
              slidesPerView: 3,
              spaceBetween: 20
            }
          }
            // ... Adicione mais breakpoints conforme necessário
          }
          pagination={{
            clickable: true,
          }}

          modules={[Pagination]}
          className="mySwiper"
        >

          <SwiperSlide key='1' >
            <CardServices status={serviceStatus('autorizados')} icone={'/icones/registoMedicamentos.svg'} nomeService={'LISTA DE MEDICAMENTOS REGISTADOS EM ANGOLA'} link={'/informacoes?menu=MEDICAMENTOS&opcao=Medicamento Aprovado'} />
          </SwiperSlide>

          <SwiperSlide key='2'>
            <CardServices status={serviceStatus('estabelecimentosLicenciados')} icone={'/icones/Licenciamento.svg'} nomeService={'LISTA DE ESTABELECIMENTOS FARMACÊUTICOS LICENCIADOS'} link={'/estabelecimentos-categorias-armed'} />
          </SwiperSlide>

          <SwiperSlide key='3'>
            <CardServices status={serviceStatus('registosMedicamentos')} icone={'/icones/Medicamentos_autorizados.svg'} nomeService={'BASE DE DADOS DE MEDICAMENTOS'} link={'/medicamentos/aprovado?page=1'} />
          </SwiperSlide>

        </Swiper>
      </Container>
    </div>
  )
}